import SubjectMonitoringService from '@pages-clean/subject-monitoring/subject-hub/subject-monitoring.service';

export const SubjectReviewActivityLogApi = {
    invalidateGetActivityEntries: () => {
        SubjectMonitoringService.refreshSubjectReviewActivityLogGrid();
        // If a "useGetActivityEntriesQuery" is ever added, invalidate it here by key
    },
} as const;
